import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import SettingItem from '../SettingItem'

interface QuoteSettingsProps {
  formPayload : UseFormPayload,
}

const QuoteSettings = (props: QuoteSettingsProps) => {
  const { formPayload } = props

  const {
    entityState: {
      options: {
        force_quote_pricing,
        include_campaign_fee_on_quotes,
        new_quote_default,
        payment_terms_unit,
        payment_terms_value,
        recalculate_quote_editions,
        require_quote_authorization,
        require_quote_contributions,
        require_quote_for_orders,
        require_quote_item_required_by_date,
        skip_quote_validation,
      },
    },
    handlers,
  } = formPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Quotes">
      <SettingItem
        isChecked={new_quote_default === 'template'}
        title="New Quotes"
        secondaryText="New quotes must use existing quote template"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            name="options.new_quote_default"
            value={new_quote_default}
            {...handlers}
          >
            <option value="blank">Empty Quote (Default)</option>
            <option value="template">Must use Template</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={require_quote_for_orders}
        title="Quote for Orders"
        secondaryText="Agency requires approved quote to order"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.require_quote_for_orders"
            value={require_quote_for_orders}
            {...handlers}
          >
            <option value="false">Not Required (Default)</option>
            <option value="true">Required</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={require_quote_authorization}
        title="Quote Authorisation"
        secondaryText="Agency requires quote authorisation to order"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.require_quote_authorization"
            value={require_quote_authorization}
            {...handlers}
          >
            <option value="false">Not Required (Default)</option>
            <option value="true">Required</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={require_quote_contributions}
        title="Quote Contributions"
        secondaryText="Quote contributions must match total to order"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.require_quote_contributions"
            value={require_quote_contributions}
            {...handlers}
          >
            <option value="false">Not Required (Default)</option>
            <option value="true">Required</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={require_quote_item_required_by_date}
        title="Assign Item Dates on Approval"
        secondaryText="Includes Item Date assignment (optional) as part of Approval workflow"
      >
        <Form.Field>
          {/*
            // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.require_quote_item_required_by_date"
            value={require_quote_item_required_by_date}
            {...handlers}
          >
            <option value="false">No (Default)</option>
            <option value="true">Yes</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={include_campaign_fee_on_quotes}
        title="Campaign Fee"
        secondaryText="Campaign fee automatically added to quotes"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.include_campaign_fee_on_quotes"
            value={include_campaign_fee_on_quotes}
            {...handlers}
          >
            <option value="false">No</option>
            <option value="true">Yes (Default)</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={recalculate_quote_editions}
        title="Recalculate Editions"
        secondaryText="Publication Editions recalculated on quote approval"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.recalculate_quote_editions"
            value={recalculate_quote_editions}
            {...handlers}
          >
            <option value="false">No (Default)</option>
            <option value="true">Yes</option>
          </select>
        </Form.Field>
      </SettingItem>

      <SettingItem
        isChecked={skip_quote_validation}
        title="Skip Quote Validation"
        secondaryText="Quote pricing will not be validated and may differ from order price"
      >
        <Form.Field>
          {/*
           // @ts-expect-error TS2322 */}
          <select
            data-value-type="boolean"
            name="options.skip_quote_validation"
            value={skip_quote_validation}
            {...handlers}
          >
            <option value="false">No (Default)</option>
            <option value="true">Yes</option>
          </select>
        </Form.Field>
      </SettingItem>

      {skip_quote_validation && (
        <SettingItem
          isChecked={force_quote_pricing}
          title="Force Quote Pricing"
          secondaryText="Orders will use quote pricing and may differ from the provider price list"
        >
          <Form.Field>
            {/*
             // @ts-expect-error TS2322 */}
            <select
              data-value-type="boolean"
              name="options.force_quote_pricing"
              value={force_quote_pricing}
              {...handlers}
            >
              <option value="false">No (Default)</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </SettingItem>
      )}

      <SettingItem
        isChecked={!!payment_terms_value}
        title="Payment Terms"
        secondaryText="How long after invoice is payment due"
      >
        <Form.Row>
          <Form.Field>
            <input
              data-value-type="number"
              name="options.payment_terms_value"
              style={{ marginRight: 8 }}
              type="number"
              value={payment_terms_value}
              {...handlers}
            />
          </Form.Field>

          <Form.Field>
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.payment_terms_unit"
              value={payment_terms_unit}
              {...handlers}
            >
              <option value="days">Days</option>
              <option value="months">Months</option>
            </select>
          </Form.Field>
        </Form.Row>
      </SettingItem>
    </DashboardModule>
  )
}

export default QuoteSettings
